import React from 'react';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import profilePlaceholder from '../../includes/images/profile-placeholder.png';
import { rootRoutes, sidebarRoutes } from '../../app.modules';
import { ChildCareOutlined } from '@material-ui/icons';
import { useSelector, useDispatch } from 'react-redux'

const ChildMenu = ({ children, hover, hoverState, menuName, accessList }) => {
    const [childHoverState, setChildHoverState] = React.useState(hoverState);

    var displayChild = Array(children.length).fill(false);

    const onHover = (name) => {
        setChildHoverState({
            ...childHoverState,
            [name]: true,
        })
    }

    const onLeave = (name) => {
        setChildHoverState({
            ...childHoverState,
            [name]: false,
        })
    }

    children.forEach((child, index) => {
        child.children && child.children.forEach(innerChild => {
            if (accessList && accessList.includes(innerChild.menuName)) {
                displayChild[index] = true;
            }
        });
    });

    return (
        <ul className={`child-menu ${hover ? 'show' : ''}`}>
            {children.map((route, i) => {
                if (route.children && displayChild[i]) {
                    return (<li key={`ch-${i}`}
                        onMouseOver={() => onHover(`hover-child-${i}`)}
                        onMouseLeave={() => onLeave(`hover-child-${i}`)}>
                        <a href='' style={childHoverState[`hover-child-${i}`] ? { backgroundColor: 'rgb(82, 82, 82)', color: 'white', textShadow: 'rgba(0, 0, 0, 0.7) 1px 1px 1px' } : {}}>
                            {` ${route.label}`}
                            {route.children.length > 0 &&
                                <i className={`fa fa-chevron-right`}></i>
                            }
                        </a>
                        {route.children && route.children.length > 0 &&
                            <ul className={`child-menu-2 ${childHoverState[`hover-child-${i}`] ? 'show' : ''}`}>
                                {route.children.map((innerChild, ndx) => {
                                    return (
                                        innerChild.path && innerChild.showNav && (accessList && accessList.includes(innerChild.menuName)) ?
                                            <li key={`child-menu-${ndx}`}>
                                                {
                                                    innerChild.externalPath ?
                                                        <a href={innerChild.path}>
                                                            {innerChild.label}
                                                        </a>
                                                        :
                                                        <Link to={{ pathname: innerChild.path }}>
                                                            {innerChild.label}
                                                        </Link>
                                                }
                                            </li> : ''
                                    );
                                })}
                            </ul>
                        }
                    </li>)
                }

                return (
                    route.path && route.showNav && (accessList && accessList.includes(route.menuName)) ?
                        <li key={`child-inner-${i}`}>
                            {
                                route.externalPath ?
                                    <a href={route.path}>
                                        {route.label}
                                    </a>
                                    :
                                    <Link to={{ pathname: route.path }}>
                                        {route.label}
                                    </Link>
                            }
                        </li> : ''
                );
            })}
        </ul>
    );
}

const Sidenav = React.memo(({ moduleList, accessList, userList }) => {
    const publicData = JSON.parse(localStorage.getItem('publicLoginData'))
    // user info
    // const staticName = userList.userFullName
    const staticName = publicData !== null ? publicData.CompleteName : userList.userFullName
    const staticRole = userList.position


    let hoverStates = {};
    sidebarRoutes.forEach((main, mainNdx) => {
        hoverStates[`hover${mainNdx}`] = false;
        if (main.children && main.children.length > 0) {
            main.children.forEach((child, childNdx) => {
                hoverStates[`hover-child-${childNdx}`] = false;
            });
        }
    })

    const [hoverState, setHoverState] = React.useState(hoverStates);

    return (
        <div id="mySidenav" className="custom-sidenav ng-scope" data-ng-if="authentication.isAuth">
            <div className="sidenav-block-user">
                <span className="sidenav-thumb-user">
                    <img className="employee-img-resize-fit" alt="Profile Picture" src={profilePlaceholder} />
                </span>
                <h4 className="name ng-binding">{staticName}</h4>
                <p className="position ng-binding">{staticRole}</p>
            </div>
            <nav className="custom-menu">
                <ul>
                    {sidebarRoutes.map((route, i) => {
                        route.children
                        if (route.children && (moduleList && moduleList.includes(route.menuName))) {
                            return (
                                <li key={`side-${i}`}
                                    onMouseOver={() => setHoverState({ ...hoverState, [`hover${i}`]: true })}
                                    onMouseLeave={() => setHoverState({ ...hoverState, [`hover${i}`]: false })}>
                                    <a href='' style={hoverState[`hover${i}`] ? { backgroundColor: 'rgb(82, 82, 82)', color: 'white', textShadow: 'rgba(0, 0, 0, 0.7) 1px 1px 1px' } : {}}>
                                        <span className='icon-sidenav-menu'>
                                            <i className={`fa ${route.icon}`}></i>
                                        </span>
                                        {` ${route.label}`}
                                        {route.children.length > 0 &&
                                            <i className={`fa fa-chevron-right`}></i>
                                        }
                                    </a>
                                    {route.children.length > 0 &&
                                        <ChildMenu
                                            children={route.children}
                                            hover={hoverState[`hover${i}`]}
                                            hoverState={hoverState}
                                            menuName={route.menuName}
                                            accessList={accessList}
                                        />
                                    }
                                </li>
                            );
                        }

                        return (
                            route.path && route.showNav && (moduleList && moduleList.includes(route.menuName)) ?
                                <li key={i}>
                                    {
                                        route.externalPath ?
                                            <a href={route.path}>
                                                {route.icon ? <span className='icon-sidenav-menu'><i className={`fa ${route.icon}`}></i></span> : null}
                                                {route.label}
                                            </a>
                                            :
                                            <Link to={{ pathname: route.path }}>
                                                {route.icon ? <span className='icon-sidenav-menu'><i className={`fa ${route.icon}`}></i></span> : null}
                                                {route.label}
                                            </Link>
                                    }
                                </li> :
                                (publicData !== null && route.menuName === 'PUBLIC') ? (
                                    <li key={i}>
                                        {
                                            route.externalPath ?
                                                <a href={route.path}>
                                                    {route.icon ? <span className='icon-sidenav-menu'><i className={`fa ${route.icon}`}></i></span> : null}
                                                    {route.label}
                                                </a>
                                                :
                                                <Link to={{ pathname: route.path }}>
                                                    {route.icon ? <span className='icon-sidenav-menu'><i className={`fa ${route.icon}`}></i></span> : null}
                                                    {route.label}
                                                </Link>
                                        }
                                    </li>
                                ) : ''
                        );
                    })}
                </ul>
            </nav>
        </div>
    );
});

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        user: state.auth.account,
        moduleList: state.auth.credentials.moduleAccessList,
        accessList: state.auth.credentials.accessList,
        userList: state.auth.credentials,
    }
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(Sidenav);